export default __webpack_public_path__ + "static/dots-150ad617895b95bfa0807b0e6408348d.png";